import {
  Dialog,
  DialogContent,
  CircularProgress,
  Typography,
  Box,
} from "@mui/material";

const LoaderDialog = ({ open, message = "Cargando..." }) => {
  return (
    <Dialog
      open={open}
      PaperProps={{
        style: {
          backgroundColor: "rgba(255, 255, 255, 0.95)",
          padding: "2rem",
          borderRadius: "12px",
          textAlign: "center",
        },
      }}
    >
      <DialogContent>
        <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
          <CircularProgress color="primary" />
          <Typography variant="body1" color="textSecondary">
            {message}
          </Typography>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default LoaderDialog;
